import React from "react";

import Button from "@atoms/Button";
import Icon from "@atoms/Icon";

import { IconName } from "@const/enum";

interface IProps {
  removeDisabled?: boolean;
  quantity: number;
  handleChange: (num: number) => void;
  quantityAvailable?: number;
}

export default function Stepper({ removeDisabled, quantity, handleChange, quantityAvailable = 99 }: IProps) {
  const handleQuantity = (type: "add" | "remove") => {
    if (type === "add") {
      if (quantityAvailable >= quantity) {
        handleChange(quantity + 1);
      }
    }

    if (type === "remove") {
      handleChange(quantity - 1);
    }
  };

  return (
    <div className="flex h-9 w-fit items-center rounded-md bg-tuneGrey-200 pc:h-7.5">
      <Button
        disabled={removeDisabled}
        onClick={() => {
          handleQuantity("remove");
        }}
        styleType="secondary"
        variant="containedIcon"
      >
        <Icon name={IconName.Minus_100} />
      </Button>
      <div className="min-w-8 text-center">{quantity}</div>
      <Button
        onClick={() => {
          handleQuantity("add");
        }}
        styleType="secondary"
        variant="containedIcon"
      >
        <Icon name={IconName.Plus_100} />
      </Button>
    </div>
  );
}
